// extracted by mini-css-extract-plugin
module.exports = {"errorText":"Login_errorText__1mUjX","forgotblock":"Login_forgotblock__1SXdt","forgotPassword":"Login_forgotPassword__3KHcy","SignUpBlock":"Login_SignUpBlock__2iY5U"};